export enum Role {
  P = 1,
  LP,
  LR,
  CR,
  RR,
  CFO,
  DIR,
  Admin,
  Auditor,
}

export function getRoleName(role): string {
  let r = Number(role);
  switch (r) {
    case Role.P: return 'P';
    case Role.LP: return 'LP';
    case Role.LR: return 'LR';
    case Role.CR: return 'CR';
    case Role.RR: return 'RR';
    case Role.CFO: return 'CFO';
    case Role.DIR: return 'DIR';
    case Role.Admin: return 'Admin';
    case Role.Auditor: return 'Auditor';
    default:
      return '';
  }
}

export function getRoleNum(role: string): number {
  switch (role) {
    case 'P': return Role.P;
    case 'LP': return Role.LP;
    case 'LR': return Role.LR;
    case 'CR': return Role.CR;
    case 'RR': return Role.RR;
    case 'CFO': return Role.CFO;
    case 'DIR': return Role.DIR;
    case 'Admin': return Role.Admin;
    case 'Auditor': return Role.Auditor;
    default:
      return Role.Auditor;
  }
}
